import { computed, nextTick, Ref, ref, watch } from 'vue'
import { get, cloneDeep } from 'lodash'

import { useRepositoriesStore } from '@/store/repositories/index'

export const rebaseSettings = (key: string | string[]) => {
  const repositoriesStore = useRepositoriesStore()
  const oldValue = get(repositoriesStore.getCurrentUISettings, key)
  if (oldValue && !oldValue.used) {
    repositoriesStore.setCurrentUISettings([
      key,
      {
        ...oldValue,
        used: true,
      },
    ])
    return cloneDeep(oldValue)
  } else {
    return null
  }
}

export const useUISettings = <T>(key: string | string[], defaultValue: T) => {
  const repositoriesStore = useRepositoriesStore()

  const internalValue = ref(defaultValue) as Ref<T>
  const isInit = ref(false)

  const repoUiSettings = computed(() => repositoriesStore.getCurrentUISettings)
  const currentValue = computed(() => get(repoUiSettings.value, key))

  const data = computed({
    get() {
      return internalValue.value
    },
    set(value) {
      if (!isInit.value) return
      internalValue.value = value || defaultValue
      repositoriesStore.setCurrentUISettings([[key, value]])
    },
  })

  watch(
    () => repositoriesStore.getCurrentId,
    async rid => {
      if (!rid) return
      isInit.value = false
      const value = get(repoUiSettings.value, key)
      internalValue.value = value || defaultValue
      await nextTick()
      isInit.value = true
    },
    { immediate: true },
  )

  watch(currentValue, value => {
    if (value === internalValue.value) return
    internalValue.value = value
  })

  return data
}
